export class DDDrive {
	isDDDrive: boolean;
	DDDriveField?: DDDriveField;
}

export class DDDriveField {
	PickupAddress: {
		CityName: string;
		RegionName: string;
		StreetName: string;
		UnitNumber: string;
		PostalCode: string;
	};
	DropoffAddress: {
		CityName: string;
		RegionName: string;
		StreetName: string;
		UnitNumber: string;
		PostalCode: string;
	};
	OrderSubtotalAmount?: number;
	DeliveryDateTime?: string;
	PickupDateTime?: string;
	ConceptRestaurantCode: string;
	ConceptCode: string;
	PickupPhoneNumber?: string;
	PickupInstructions?: string;
	Customer?: {
		phoneNumber: string;
		BusinessName: string;
		GivenName: string;
		Surname: string;
		EmailAddress: string;
		IsSendNotificationsFlag: boolean;
	};
	DropoffInstructions?: string;
	TipAmount?: number;
	ContainsAlcoholFlag?: boolean;
	IsBarcodeScanningRequiredFlag?: boolean;
	ItemCount?: number;
	IsSignatureRequiredFlag?: boolean;
}
